<template>
  <a-card style="height: 100%">
    <a-row :gutter="[8, 8]">
      <a-col :span="24">
        <a-typography-text class="text-gray-8 fw-semibold">
          Trabajo terminado
          <a-tooltip>
            <template #title>Solicitudes ejecutadas y canceladas</template>
            <InfoCircleOutlined />
          </a-tooltip>
        </a-typography-text>
      </a-col>
      <a-col :span="24">
        <a-progress stroke-linecap="square" :percent="value" />
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { InfoCircleOutlined } from '@ant-design/icons-vue';
export default {
  components: {
    InfoCircleOutlined
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
};
</script>
